// https://fluentsite.z22.web.core.windows.net/quick-start
import React from "react";
import { Loader } from "@fluentui/react-northstar";
import { BrowserRouter, Redirect, Route } from "react-router-dom";
import { useTeamsFx } from "@microsoft/teamsfx-react";
import { TeamsFxContext } from "./Context";
import { TeamsTheme } from "@fluentui/react-teams/lib/cjs/themes";
import { Provider } from "@fluentui/react-teams";
import {
  Capture,
  NotSupported,
  BadConditions,
  Results,
} from "tabs/CaptureTab/Views";
import "./App.scss";
import Home from "pages/Home";
import Nav from "components/Nav";
import Register from "pages/Register";
import { AuthProvider } from "components/context/AuthContext";
import Login from "pages/Login";
import { createBrowserHistory } from "history";
import ForgotPassword from "pages/ForgotPassword";
import { Toaster } from "react-hot-toast";
// import { AnimatePresence } from "framer-motion";

/**
 * The main app which handles the initialization and routing
 * of the app.
 */
export default function App() {
  const { loading, theme, themeString, teamsfx } = useTeamsFx();

  const hist = createBrowserHistory();

  // const location = useLocation();

  const pathname = window.location.pathname;

  return (
    <TeamsFxContext.Provider value={{ theme, themeString, teamsfx }}>
      <Provider themeName={TeamsTheme.Default} lang="en-US">
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-center" reverseOrder={false} />
            {/* <Route exact path="/">
              <Redirect to="/capture" />
            </Route> */}
            {loading ? (
              <Loader style={{ margin: 100 }} />
            ) : (
              <>
                <Route
                  path="/capture"
                  render={({ match: { url } }) => (
                    <>
                      <Route exact path={`${url}/`} component={Capture} />
                      <Route
                        exact
                        path={`${url}/not-supported`}
                        component={NotSupported}
                      />
                      <Route
                        exact
                        path={`${url}/bad-conditions`}
                        component={BadConditions}
                      />
                      <Route
                        exact
                        path={`${url}/results`}
                        component={Results}
                      />
                    </>
                  )}
                />
              </>
            )}

            <Route exact path={`/`} component={Home} />
            <Route exact path={`/register`} component={Register} />
            <Route exact path={`/login`} component={Login} />
            <Route exact path={`/forgot-password`} component={ForgotPassword} />
          </BrowserRouter>
        </AuthProvider>
      </Provider>
    </TeamsFxContext.Provider>
  );
}
